import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
interface Testimonial {
  name: string;
  age: number;
  location: string;
  rating: number;
  quote: string;
  image: string;
}
export function TestimonialsSection() {
  const testimonials: Testimonial[] = [{
    name: 'Ana R.',
    age: 32,
    location: 'Miami, FL',
    rating: 5,
    quote: 'No sabía cuánto me estaba autosaboteando hasta que hice este test. Pensé que era "solo tarot", pero terminé llorando de claridad. Tomé una decisión que había pospuesto por AÑOS. Gracias por esto 🙏🔥',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop&q=80'
  }, {
    name: 'Luis M.',
    age: 28,
    location: 'Los Angeles, CA',
    rating: 4.5,
    quote: 'No creo en cosas místicas, pero esto no es magia… es psicología emocional pura. Las preguntas me hicieron ver cosas que ya sabía pero no quería admitir. Brutalmente honesto 😳✨',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&q=80'
  }, {
    name: 'Daniela S.',
    age: 41,
    location: 'Houston, TX',
    rating: 5,
    quote: 'Sentí por primera vez que mis decisiones tenían sentido. No me dijo qué hacer, me mostró lo que estaba evitando. Eso cambia todo. Es como hablar con tu yo más sabio 💛',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop&q=80'
  }, {
    name: 'Marisol G.',
    age: 35,
    location: 'Phoenix, AZ',
    rating: 4,
    quote: 'No pensé que un test pudiera sentirse así. Es como si alguien te leyera por dentro. Terminé con paz mental… y una respuesta que llevaba meses buscando 🌿💫',
    image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&h=400&fit=crop&q=80'
  }, {
    name: 'Javier P.',
    age: 29,
    location: 'New York, NY',
    rating: 4.5,
    quote: 'Si estás confundido con tu vida, hazlo. No promete milagros, pero sí verdades. Me dio una dirección clara: ahora sé qué paso dar. Eso no tiene precio 🚀',
    image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=400&fit=crop&q=80'
  }, {
    name: 'Sofía L.',
    age: 34,
    location: 'Chicago, IL',
    rating: 5,
    quote: 'Pensé que tenía un problema con mi pareja. Descubrí que el problema era conmigo. Esta experiencia me salvó de una decisión impulsiva. Ojalá lo hubiera hecho antes 😅💔➡️✨',
    image: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=400&h=400&fit=crop&q=80'
  }];
  const renderRating = (rating: number) => {
    const stars = [];
    // Render each of the 5 star positions
    for (let i = 1; i <= 5; i++) {
      if (i <= Math.floor(rating)) {
        // Full star
        stars.push(<span key={i} data-id="element-306">⭐</span>);
      } else if (i === Math.ceil(rating) && rating % 1 !== 0) {
        // Half star (use a different emoji for visual distinction)
        stars.push(<span key={i} data-id="element-307">⭐</span>);
      } else {
        // Empty star
        stars.push(<span key={i} className="opacity-30" data-id="element-308">
            ⭐
          </span>);
      }
    }
    return stars;
  };
  return <section className="py-20 px-4 bg-[#111522] border-t border-[#3b3330]" data-id="element-309">
      <div className="max-w-6xl mx-auto" data-id="element-310">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="text-center mb-4" data-id="element-311">
          <div className="flex items-center justify-center gap-2 mb-1" data-id="element-312">
            <Sparkles className="w-5 h-5 text-[#CFA86A] fill-[#CFA86A]" data-id="element-313" />
            <p className="text-sm text-[#CFA86A] font-semibold tracking-wide" data-id="element-314">
              Puntuación media: 4.8/5
            </p>
          </div>
          <p className="text-xs text-[#F7F5F2]/60" data-id="element-315">
            basada en experiencias reales.
          </p>
          <p className="text-xs text-[#CFA86A]/80 mt-2 font-semibold" data-id="element-316">
            Más de 10,000 copias vendidas
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        delay: 0.1,
        ease: [0.22, 1, 0.36, 1]
      }} className="text-center mb-16" data-id="element-317">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-318">
            <Sparkles className="w-8 h-8 text-[#CFA86A] fill-[#CFA86A]" data-id="element-319" />
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-[#F7F5F2]" data-id="element-320">
              Reseñas
            </h2>
          </div>
          <p className="text-lg text-[#F7F5F2]/70 max-w-2xl mx-auto" data-id="element-321">
            Personas que llegaron con dudas y se fueron con claridad.
          </p>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-322">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.1,
          ease: [0.22, 1, 0.36, 1]
        }} className="bg-[#0C0A09] rounded-lg p-6 border border-[#CFA86A]/20" style={{
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
        }} data-id="element-323">
              {/* Profile */}
              <div className="flex items-center gap-4 mb-4" data-id="element-324">
                <img src={testimonial.image} alt={testimonial.name} className="w-14 h-14 rounded-full object-cover border-2 border-[#CFA86A]/30" data-id="element-325" />
                <div className="flex-1" data-id="element-326">
                  <h4 className="text-[#F7F5F2] font-semibold" data-id="element-327">
                    {testimonial.name}
                  </h4>
                  <p className="text-[#F7F5F2]/50 text-xs" data-id="element-328">
                    {testimonial.age} años
                  </p>
                  <p className="text-[#CFA86A]/70 text-xs mt-0.5" data-id="element-329">
                    📍 {testimonial.location}
                  </p>
                </div>
              </div>

              {/* Rating */}
              <div className="flex gap-1 mb-4 text-base" data-id="element-330">
                {renderRating(testimonial.rating)}
              </div>

              {/* Quote */}
              <p className="text-[#F7F5F2]/80 text-sm leading-relaxed" data-id="element-331">
                "{testimonial.quote}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}